(function () {
  'use strict';

  if (window.WiperProHomepageCarFilterValidation) return;

  const attentionClass = 'car-select--needs-attention';
  const fieldSelector = '[data-car-make], [data-car-model]';

  function clearValidation(root) {
    root.querySelectorAll(fieldSelector).forEach(function (select) {
      const wrapper = select.closest('.car-select');
      if (wrapper) wrapper.classList.remove(attentionClass);
      select.removeAttribute('aria-invalid');
    });
  }

  function showFirstIncompleteField(root) {
    const makeSelect = root.querySelector('[data-car-make]');
    const modelSelect = root.querySelector('[data-car-model]');
    clearValidation(root);

    const incompleteSelect = !makeSelect || !makeSelect.value
      ? makeSelect
      : (!modelSelect || !modelSelect.value ? modelSelect : null);

    if (!incompleteSelect) return null;

    const wrapper = incompleteSelect.closest('.car-select');
    if (wrapper) wrapper.classList.add(attentionClass);
    incompleteSelect.setAttribute('aria-invalid', 'true');
    incompleteSelect.focus({ preventScroll: true });
    return incompleteSelect;
  }

  function initRoot(root) {
    if (root.dataset.carFilterValidationReady === 'true') return;

    const submit = root.querySelector('[data-car-submit]');
    const makeSelect = root.querySelector('[data-car-make]');
    const modelSelect = root.querySelector('[data-car-model]');
    if (!submit || !makeSelect || !modelSelect) return;

    root.dataset.carFilterValidationReady = 'true';
    submit.addEventListener('click', function () {
      showFirstIncompleteField(root);
    });
    makeSelect.addEventListener('change', function () {
      clearValidation(root);
    });
    modelSelect.addEventListener('change', function () {
      clearValidation(root);
    });
  }

  function init(scope) {
    scope.querySelectorAll('.car-filter').forEach(initRoot);
  }

  window.WiperProHomepageCarFilterValidation = {
    clearValidation,
    showFirstIncompleteField,
    init,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
